import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import { AppBar, Toolbar } from '@material-ui/core'
import { authHeader } from '../../components/auth-header';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
    container: {
        display: 'flex',
        padding: 10,
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    dense: {
        marginTop: 19,
    },
    menu: {
        width: 200,
    },
});

const formStyle = {
    display: 'flex',
    padding: 10,
    flexWrap: 'wrap',
};

const formControlStyle = {
    marginLeft: 8
};


export class AnimalDetail extends Component {
    static displayName = AnimalDetail.name;

    constructor(props) {
        super(props);
        var compo = this;
        var animalId = props.match.params.id;
        var animals = JSON.parse(localStorage.getItem('animals'))
        var allAnimals = [];

        if (Array.isArray(animals)) {
            for (var i = 0; i < animals.length; i++) {
                allAnimals = allAnimals.concat(animals[i].animals);
            }
        }
        var animal = allAnimals.filter(animal => animal.animalCode === animalId).length > 0 ? allAnimals.filter(animal => animal.animalCode === animalId)[0] : { animalCode: animalId };
        this.renderAnimalInfo = this.renderAnimalInfo.bind(this);
        this.state = { animal: animal, loading: true };

        fetch('api/Animal/GetAnimalInfo?id=' + animalId, { headers: authHeader() })
            .then(response => response.json())
            .then(data => {
                if (data.message) {
                    if (localStorage.getItem("animals") && JSON.parse(localStorage.getItem('animals')).filter(animList => animList.breeding === compo.state.animal.breedingCode).length > 0 && JSON.parse(localStorage.getItem('animals')).filter(animList => animList.breeding === compo.state.animal.breedingCode)[0].animals.filter(animal => animal.animalCode === compo.state.animal.animalCode).length > 0) {
                        compo.setState({ animal: JSON.parse(localStorage.getItem('animals')).filter(animList => animList.breeding === compo.state.animal.breedingCode)[0].animals.filter(animal => animal.animalCode === compo.state.animal.animalCode)[0], loading: false });
                    } else {
                        compo.setState({ loading: false });
                    }
                    return;
                }
                var currentAnimals = localStorage.getItem('animals') && Array.isArray(JSON.parse(localStorage.getItem('animals'))) ? JSON.parse(localStorage.getItem('animals')) : [];
                var animalsForBreeding = currentAnimals.filter(animList => animList.breeding === data.breedingCode).length > 0 ? currentAnimals.filter(animList => animList.breeding === data.breedingCode)[0].animals : [];
                //odstranenie zvierata zo zoznamu a push noveho s rozsirenymi datami
                animalsForBreeding = animalsForBreeding.filter(animal => animal.animalCode !== data.animalCode);
                animalsForBreeding.push(data);
                currentAnimals = currentAnimals.filter(animList => animList.breeding !== data.breedingCode);
                currentAnimals.push({ breeding: data.breedingCode, animals: animalsForBreeding});

                localStorage.setItem('animals', JSON.stringify(currentAnimals))
                compo.setState({ animal: data, loading: false });
            }).catch(function (err) {
                if (localStorage.getItem("animals") && JSON.parse(localStorage.getItem('animals')).filter(animList => animList.breeding === compo.state.animal.breedingCode).length > 0 && JSON.parse(localStorage.getItem('animals')).filter(animList => animList.breeding === compo.state.animal.breedingCode)[0].animals.filter(animal => animal.animalCode === compo.state.animal.animalCode).length > 0) {
                    compo.setState({ animal: JSON.parse(localStorage.getItem('animals')).filter(animList => animList.breeding === compo.state.animal.breedingCode)[0].animals.filter(animal => animal.animalCode === compo.state.animal.animalCode)[0], loading: false });
                } else {
                    compo.setState({ loading: false });
                }

                console.log("request failed, fetching data from storage");
            });
    }

    renderAnimalInfo(classes) {
        if (this.state.animal && this.state.animal.bornDate) {
            return (
                <div>
                    <AppBar position="static">
                        <Toolbar>
                            <Typography className={classes.grow} variant="h6" color="inherit">{this.state.animal.animalCode}</Typography>
                        </Toolbar>
                    </AppBar>
                    <Card>
                        <form style={formStyle} noValidate autoComplete="off">
                            <FormControl style={formControlStyle} margin="normal">
                                <TextField
                                    id="born"
                                    label="Narodená"
                                    defaultValue={this.state.animal.bornDate}
                                    className={classes.textField}
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </FormControl>
                            <FormControl style={formControlStyle} margin="normal">
                                <TextField
                                    id="standard-read-only-input"
                                    label="Farba"
                                    defaultValue={this.state.animal.color}
                                    className={classes.textField}
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </FormControl>
                            <FormControl style={formControlStyle} margin="normal">
                                <TextField
                                    id="standard-read-only-input"
                                    label="Otec"
                                    defaultValue={this.state.animal.father}
                                    className={classes.textField}
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </FormControl>
                            <FormControl style={formControlStyle} margin="normal">
                                <TextField
                                    id="standard-read-only-input"
                                    label="Matka"
                                    defaultValue={this.state.animal.mother}
                                    className={classes.textField}
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </FormControl>
                            <FormControl style={formControlStyle} margin="normal">
                                <TextField
                                    id="standard-read-only-input"
                                    label="Plemenná skladba"
                                    defaultValue={this.state.animal.bloodraces}
                                    className={classes.textField}
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </FormControl>
                        </form>
                        <br />
                    </Card>
                </div>
            );
        } else {
            return (
                <div>
                    <AppBar position="static">
                        <Toolbar>
                            <Typography className={classes.grow} variant="h6" color="inherit">{this.state.animal.animalCode}</Typography>
                        </Toolbar>
                    </AppBar>
                    <Card>
                        <Typography style={{padding: 10}} className={classes.grow} variant="h6" color="inherit">Pre zobrazenie detailných informácií si musíte zviera najprv zobraziť online.</Typography>
                    </Card>
                </div>
            );
        }

    }

    renderBusyIndicator(props) {
        return (
            <Paper style={{ padding: 15 }}>
                <CircularProgress className={props.progress} />
            </Paper>
        );
    }

    render() {
        const classes = this.props;
        console.log(classes);
        let contents = this.state.loading ? this.renderBusyIndicator(classes) : this.renderAnimalInfo(classes);

        return (
            <div>
                {contents}
                <br />
                <Button
                    component={Link} to={{ pathname: "/insemination-detail/null/" + this.state.animal.animalCode +"/null" }}
                    variant="contained"
                    color="secondary"
                >Pridaj insemináciu</Button>
            </div>
        );
    }
} withStyles(styles)




// WEBPACK FOOTER //
// ./src/components/technik/AnimalDetail.jsx